<template>
  <div class="w-full flex p-4 items-center justify-between flex-grow">
    <div>
      <h5>{{ customerCourse.course.name }}</h5>
      <p class="text-sm font-normal">
        {{ customerCourse.courseRun.information }}
      </p>
      <p v-if="startDateLabel" class="text-xs opacity-70">
        {{ $t('general.colonSeparator', { label1: $t('general.start'), label2: startDateLabel }) }}
      </p>
      <p v-if="nextDateLabel" class="text-xs opacity-70">
        {{ $t('general.colonSeparator', { label1: $t('general.next'), label2: nextDateLabel }) }}
      </p>

    </div>

    <div class="flex items-center">
      <div class="form-item--status mr-4 flex items-center space-x-1">
        <o-chip v-if="customerCourse.eligibleMakeupCount > 0" flat variant="info" size="xs" square>
          {{ customerCourse.eligibleMakeupCount }} {{ customerCourse.eligibleMakeupCount === 1 ? 'make-up' : 'make-ups' }}
        </o-chip>
        <o-chip v-if="isExpired" flat variant="warning" size="xs" square>
          Expired
        </o-chip>
        <o-chip v-if="isExpended" flat variant="warning" size="xs" square>
          Expended
        </o-chip>
        <o-chip v-if="isEarly" flat variant="info" size="xs" square>
          Early bird
        </o-chip>
        <o-chip v-if="isPaid" flat variant="success" size="xs" square>
          Paid
        </o-chip>
        <o-chip v-if="isCancelled" flat variant="danger" size="xs" square>
          {{ $t('pages.customer.course.status.cancelled') }}
        </o-chip>
        <o-chip v-if="onlineTermsAgreed" flat variant="success" size="xs" square>
          {{ $t('reservation.termsAgreed') }}
        </o-chip>
      </div>
      <div class="flex items-center space-x-1">
        <o-tooltip text="Edit course">
          <o-panel-link :path="`/customer/course/${customerCourse.idCustomerCourse}`" tag="o-button" flat size="sm" icon="edit" />
        </o-tooltip>
        <!--<o-tooltip v-if="!hasOrder" text="New sale">
          <o-button flat size="sm" icon="sale" variant="info" @click="handleCreateOrder" />
        </o-tooltip>
        <o-tooltip v-if="hasOrder" text="View sale">
          <o-panel-link tag="o-button" flat size="sm" icon="sale" :path="`/order/${customerCourse.order.idOrder}`" />
        </o-tooltip>-->
        <o-tooltip text="Delete">
          <o-button flat size="sm" icon="delete" variant="danger" @click="handleDelete" />
        </o-tooltip>
      </div>
    </div>

    <delete-dialog
      v-if="customerCourse"
      ref="deleteDialog"
      :customerCourse="customerCourse"
    />

    <create-order-dialog
      v-if="customerCourse"
      ref="createOrderDialog"
    />
  </div>
</template>

<script setup lang="ts">
import CreateOrderDialog from '@/components/order/actions/CreateOrder.vue'
import DeleteDialog from '@/components/customerCourse/actions/Delete.vue'
import { CustomerCourseStatus } from '~/_api/models/course'

interface Props {
  customerCourse: Record<string, any>
}

const props = defineProps<Props>()

const { $date } = useNuxtApp()

const deleteDialog = ref<any>()
const createOrderDialog = ref<any>()

const hasOrder = computed(() => !!props.customerCourse.order)

const startDateLabel = computed(() => {
  const dates = props.customerCourse?.courseRun?.dates || []
  if (!dates.length) { return null }
  const first = dates[0]
  return ($date as any).convert(first, undefined, ($date as any).presets.long)
})

const nextDateLabel = computed(() => {
  const dates = props.customerCourse?.courseRun?.dates || []
  if (!dates.length) { return null }
  const today = Number(($date as any).format(new Date()))
  const next = dates.find((d: any) => d >= today)
  return next ? ($date as any).convert(next, undefined, ($date as any).presets.long) : null
})

const isExpired = computed(() => props.customerCourse.isExpired)
const isExpended = computed(() => props.customerCourse.isExpended)
const isPaid = computed(() => props.customerCourse.isPaid)
const isEarly = computed(() => !!props.customerCourse.payment?.isEarly)
const isCancelled = computed(() => props.customerCourse.status === CustomerCourseStatus.cancelled)
const onlineTermsAgreed = computed(() => props.customerCourse.onlineTermsAgreed)

const handleDelete = () => {
  deleteDialog.value.open(props.customerCourse)
}

const handleCreateOrder = () => {
  const customer = props.customerCourse.customer
  const date = new Date()
  const items = [props.customerCourse]

  const data = {
    customer,
    date,
    items,
  }

  createOrderDialog.value.open(data)
}
</script>
